__turbopack_context__.v({
  "remote-svg": "RemoteSvg-module-scss-module__X_TJmq__remote-svg",
});
